export default class Backdrop {
    constructor() {
        this.el = null;
        this.originalScrollPosition = 0;
    }

    create() {
        if (!this.el) {
            // Store the scrolled amount
            this.originalScrollPosition = window.pageYOffset;

            this.el = document.createElement('div');
            this.el.classList.add('backdrop');
            document.body.style.top = `-${this.originalScrollPosition}px`;
            document.body.appendChild(this.el);

            this.addBodyClass();
        }
    }

    destroy() {
        if(this.el !== null) {
            this.el.remove();
            this.el = null;

            this.removeBodyClass();

            // Restore original scolling position
            window.scrollTo(0, this.originalScrollPosition);
            document.body.style.top = null;
            this.originalScrollPosition = 0;
        }
    }

    addBodyClass() {
        if (!document.body.classList.contains('no-scroll')) {
            document.body.classList.add('no-scroll');
        }
    }

    removeBodyClass() {
        if (document.body.classList.contains('no-scroll')) {
            document.body.classList.remove('no-scroll');
        }
    }
}